export default __webpack_public_path__ + "media/images/logo-symbol-wordmark-6156cdb0f057a6ccb16f0e7f7c7d1f09.svg";